import React, { PureComponent } from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import renderInputField from '../../../shared/components/form/renderInput';
import Collapse from '../../../shared/components/Collapse';
import {withTranslation} from "react-i18next";
import renderFileInputField from '../../../shared/components/form/FileInput';

class OpenGraph extends PureComponent {

  render() {
    const { handleSubmit, blog, t } = this.props;

    return (
      <Col xs={12} md={12} lg={12} xl={12}>
        <Card>
          <CardBody>
            <div className="card__title">
              <h5 className="bold-text">{t('settings.seo.title')}</h5>
              <h5 className="subhead">{t('settings.seo.subtitle')}</h5>

            </div>
            <form className="form form--horizontal" onSubmit={handleSubmit}>

              <div className="form__form-group">
                <span className="form__form-group-label">{t('settings.seo.form_default_image.label')}:</span>
                <div className="form__form-group-field">
                  <Field
                    name="opengraph_default_image_url"
                    component={renderFileInputField}
                    type="text"
                    placeholder="https://..."
                    value={blog.title}
                  />
                </div>
              </div>
              <div className="form__form-group">
                <span className="form__form-group-label">{t('settings.seo.form_default_description.label')}:</span>
                <div className="form__form-group-field">
                  <Field
                    name="opengraph_default_description"
                    component="textarea"
                    placeholder={t('settings.seo.form_default_description.placeholder')}
                  />
                </div>
              </div>
            </form>
            <Collapse title={t('settings.seo.learn_more.label')}>
              <p>{t('settings.seo.learn_more.body')}
              </p>
            </Collapse>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: 'blog_settings', // a unique identifier for this form
  enableReinitialize: true
})(withTranslation('dashboard')(OpenGraph));
